import React from 'react'
import "./index.css"

export default function Skills() {
    return (
        <section id="skills" className="section is-medium">
            <p className="title is-family-code has-text-green ">What I've Know</p>
            <p className="subtitle is-family-code has-text-centered has-text-light is-4">Technologies</p>
            <br />
            <div class="columns is-size-6">
                <div class="column has-text-centered">
                    <span className="icon">
                        <i className="fa-brands fa-python fa-5x has-text-centered"></i>
                    </span>
                    <br />
                    <span className='has-text-centered'>Python</span>
                </div>
                <div class="column has-text-centered">
                    <span className="icon">
                        <i className="fa-brands fa-java fa-5x"></i>
                    </span>
                    <br />
                    <span>Java</span>
                </div>
                <div class="column has-text-centered">
                    <span className="icon">
                        <i className="fa-solid fa-code fa-5x"></i>
                    </span>
                    <br />
                    <span>C#</span>
                </div>
                <div class="column has-text-centered">
                    <span className="icon">
                        <i className="fa-brands fa-c fa-5x"></i>
                    </span>
                    <br />
                    <span>C</span>
                </div>
            </div>
            <br />
            <div class="columns is-size-6">

                <div class="column has-text-centered">
                    <span className="icon">
                        <i className="fa-brands fa-docker fa-5x"></i>
                    </span>
                    <br />
                    <span>Docker</span>
                </div>
                <div class="column has-text-centered">
                    <span className="icon">
                        <i className="fa-brands fa-aws fa-5x"></i>
                    </span>
                    <br />
                    <span>AWS</span>
                </div>
                <div class="column has-text-centered">
                    <span className="icon">
                        <i className="fa-brands fa-jenkins fa-5x has-text-centered"></i>
                    </span>
                    <br />
                    <br />
                    <span>Jenkins</span>
                </div>
                <div class="column has-text-centered">
                    <span className="icon">
                        <i className="fa-solid fa-cloud fa-5x"></i>
                    </span>
                    <br />
                    <span>GCP</span>

                </div>
            </div>
            <br />
            <div class="columns is-size-6">

                <div class="column has-text-centered">
                    <span className="icon">
                        <i className="fa-brands fa-css3 fa-5x"></i>
                    </span>
                    <br />
                    <span>CSS</span>
                </div>
                <div class="column has-text-centered">
                    <span className="icon">
                        <i className="fa-brands fa-html5 fa-5x"></i>
                    </span>
                    <br />
                    <span>HTML5</span>
                </div>
                <div class="column has-text-centered">
                    <span className="icon">
                        <i className="fa-brands fa-react fa-5x has-text-centered"></i>
                    </span>
                    <br />
                    <span>ReactJs</span>
                </div>
                <div class="column has-text-centered">
                    <span className="icon">
                        <i className="fa-brands fa-js fa-5x has-text-centered"></i>
                    </span>
                    <br />
                    <span>Javascript</span>
                </div>
            </div>

        </section>
    )
}
